import { ShieldCheck, BadgeCheck, Clock4 } from "lucide-react";

const items = [
  { icon: ShieldCheck, label: "Licensed Virginia Home Care Organization" },
  { icon: BadgeCheck, label: "Medicaid-Approved Provider" },
  { icon: Clock4, label: "Same-Day Care Available" },
];

export default function TrustBadges({ variant = "row" }) {
  return (
    <div
      data-testid="trust-badges"
      className={`flex flex-wrap items-center ${
        variant === "row" ? "justify-center" : "justify-start"
      } gap-3 sm:gap-4`}
    >
      {items.map(({ icon: Icon, label }) => (
        <div
          key={label}
          data-testid={`trust-badge-${label.toLowerCase().replace(/\s+/g, "-")}`}
          className="flex items-center gap-2 bg-white border border-gray-200 px-4 py-2 rounded-full shadow-sm text-sm font-medium text-brand-blue-dark"
        >
          <Icon className="w-4 h-4 text-brand-amber" />
          <span>{label}</span>
        </div>
      ))}
    </div>
  );
}
